import { createTheme } from '@mui/material/styles';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
// const LOADER_SIZE = 20;

declare module '@mui/material/styles' {
  interface Theme {
    labelColor?: {
      main?: string;
      background?: string;
    };
    iconColor?: {
      main?: string;
    },
    tagColor?: {
      background?: string;
    }
    dividerColor?: {
      main?: string;
    }
    buttonColor?: {
      main?: string;
    }
    ekomeColor: {
      main?: string;
    }
    titleColor: {
      main?: string;
    }
  }
  interface ThemeOptions {
    labelColor?: {
      main?: string;
      background?: string;
    };
    iconColor?: {
      main?: string;
    }; 
    tagColor?: {
      background?: string;
    };
    dividerColor?: {
      main?: string;
    };
    buttonColor: {
      main?: string;
    },
    ekomeColor: {
      main?: string;
    },
    titleColor: {
      main?: string;
    }
  }
}

const Theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    h1: {
      fontSize: '2rem',
      fontWeight: '700',
      '@media (min-width:600px)': {
        fontSize: '2.5rem',
      },
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: '700',
      '@media (min-width:600px)': {
        fontSize: '2rem',
      },
    },
    h3: {
      fontSize: '1.125rem',
      fontWeight: '700',
      '@media (min-width:600px)': {
        fontSize: '1.3rem',
      },
    },
    h4: {
      fontSize: '1rem',
      fontWeight: '700',
      '@media (min-width:600px)': {
        fontSize: '1.1rem',
      },
    },
    h5: {
      fontSize: '0.81rem',
      fontWeight: '700',
    },
    h6: {
      fontSize: '0.81rem',
      fontWeight: '700',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: '400',
      lineHeight: '1.43',
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        disablePortal: true
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '8px 22px',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              width: 250,
            },
          },
        },
      },
    },
    MuiImageList: {
      styleOverrides: {
        root: {
          img: {
            borderRadius: 20,
            minHeight: 250,
            maxHeight: 250,
          }
        }
      }
    }
  },

  palette: {
    primary: {
      main: '#1622aa',
    },
    secondary: {
      main: '#046ec5',
    },
    success: {
      main: '#00703c',
    },
    error: {
      main: '#ca2e2e',
    }
  },
  labelColor: {
    main: 'rgba(0, 0, 0, 0.87)',
    background: '#DCDCDC',
  },
  iconColor: {
    main: '#046ec5',
  },
  tagColor: {
    background: '#2d5e791f'
  },
  dividerColor: {
    main: 'rgba(0, 0, 0, 0.87)'
  },
  buttonColor: {
    main: '#1622aa'
  },
  ekomeColor: {
    main: '#1622aa',
  },
  titleColor: {
    main: '#fafafa',
  },
});

export default Theme;
